import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Divider, Typography } from "@mui/material";
import React from "react";
import PropertyManagementComponent from "./PropertyManagementComponent";

const PropertyHistory = (props) => {
    const {
        panelId,
        snapshot,
        contacts,
        personnel,
        mediaAssets,
        handleChange,
        expanded,
        role,
        property,
        autocompleteResults,
        searchKMPerson,
        handleInput,
        handleAddArrayElement,
        handleDeleteArrayElement,
        handleUpdateArrayElement,
        prop_management_contact_options,
        handleSearchCompany,
        errors,
        personnelInfo,
    } = props;

    const { terminationDate } = snapshot;
    return (
        <React.Fragment>
            <Accordion expanded={expanded === panelId} onChange={handleChange(panelId)}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                    <Typography sx={{ width: "33%", flexShrink: 0 }}>{terminationDate}</Typography>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <PropertyManagementComponent
                        role={role}
                        snapshot={snapshot}
                        snapshotContacts={contacts}
                        snapshotPersonnel={personnel}
                        snapshotMediaAssets={mediaAssets}
                        property={property}
                        propertyManagement={snapshot}
                        autocompleteResults={autocompleteResults}
                        searchKMPerson={searchKMPerson}
                        handleInput={handleInput}
                        handleAddArrayElement={handleAddArrayElement}
                        handleDeleteArrayElement={handleDeleteArrayElement}
                        handleUpdateArrayElement={handleUpdateArrayElement}
                        prop_management_contact_options={prop_management_contact_options}
                        handleSearchCompany={handleSearchCompany}
                        errors={errors}
                        isSnapshot={true}
                        personnelInfo={personnelInfo}
                    />
                </AccordionDetails>
            </Accordion>
        </React.Fragment>
    );
};

export default PropertyHistory;
